import { AppId } from 'clickNgo/configs/app'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'

export enum PartnerFlagRequestAction {
  Add = 'Add',
  Modify = 'Modify',
  Remove = 'Remove',
}

export enum PartnerFlagRequestStatus {
  New = 'New',
  Done = 'Done',
  WIP = 'WIP',
  Rejected = 'Rejected',
}

export interface IPartnerFlag {
  action?: PartnerFlagRequestAction
  agreementNumber?: string
  apolloCode?: string
  caption?: string
  code: string
  codeName: string
  codeType: ProfilingCodeType
  comment?: string
  country?: string
  currency?: string
  endDate: Date
  entryId: string
  market?: string
  newEffectiveDate?: Date
  partnerId: string
  region?: string
  revision?: number
  signatureDate?: Date
  startDate: Date
  status?: PartnerFlagRequestStatus
  topPartnerId?: string
}

export interface IPartnerFlagRequest {
  action: PartnerFlagRequestAction
  caption?: string
  code: string
  codeName: string
  comment?: string
  country?: string
  endDate: Date
  entryId: string
  market?: string
  newEffectiveDate?: Date
  notificationSendLog?: string
  partnerId: string
  processedData?: Date
  requestStarted?: Date
  source: string
  startDate: Date
  status: PartnerFlagRequestStatus
  type: ProfilingCodeType
}

export type TPartherFlagRequest = {
  Action: PartnerFlagRequestAction
  Caption?: string
  Code: string
  CodeName: string
  Comment?: string
  Country?: string
  EndDate: string
  Market?: string
  PartnerId: string
  Source: string
  StartDate: string
  Type: ProfilingCodeType
  OnboardingRequestId?: number
}

export type TPartnerFlagResponse = {
  Action: PartnerFlagRequestAction
  Caption: string
  Code: string
  CodeName: string
  Comment: string
  Country: string
  Created: Date
  CreatedBy: string
  EndDate: Date
  EntryId: string
  Market: string
  Modified: Date
  ModifiedBy: string
  NotificationSendLog: string
  NewEffectiveDate: Date
  OnboardingRequestId: number
  PartnerId: string
  Processed_Date: Date
  RequestStarted: Date
  Source: AppId
  StartDate: Date
  Status: PartnerFlagRequestStatus
  Type: ProfilingCodeType
  id: number
}

export interface IPartnerFlags {
  accreditation: IPartnerFlag[]
  program: IPartnerFlag[]
  agreement: IPartnerFlag[]
}

export type TPartnerFlagType =
  | ProfilingCodeType.Program
  | ProfilingCodeType.Accreditation
  | ProfilingCodeType.Agreement
